import React, { useState, useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { motion, AnimatePresence } from 'framer-motion';
import Section from '../components/ui/Section';
import Button from '../components/ui/Button';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const allImages = [
  // Education & Classroom
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/7ab728fa003eb0944fc5dd69f70d57d4.jpeg",
    category: "Education",
    caption: "Eager to learn: Students participating in class.",
    alt: "Students raising hands in a classroom at AGIR USA school in Guinea-Bissau"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/f1d1d816ca07b6a337f8d77627030935.jpeg",
    category: "Education",
    caption: "Joyful learning in action.",
    alt: "Smiling child writing in a notebook during a lesson"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/c1576b9634fa010d9022f2866cd52299.jpeg",
    category: "Education",
    caption: "Ready to succeed with new supplies.",
    alt: "Student showing off new school supplies provided by donors"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/5d867f9fe39ec56e4c3c698d1aa325a1.jpeg",
    category: "Education",
    caption: "Foundations of knowledge.",
    alt: "Young students focusing on their work in a rural African classroom"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/5ed951151d834b07c1a6fcdff6986792.jpeg",
    category: "Education",
    caption: "Classroom excitement.",
    alt: "Energetic classroom atmosphere in Guinea-Bissau school"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/e85f8df4ca1088998577b5cca07c0363.jpeg",
    category: "Education",
    caption: "Bright futures ahead.",
    alt: "Portrait of a student in uniform smiling confidently"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/3876d2e6c1bd9a4b6dd1f8362fd0ad58.jpeg",
    category: "Education",
    caption: "Focused learning.",
    alt: "Close up of student concentrating on a textbook"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/42856ddad8fa097d442c2f3ef46176f2.jpeg",
    category: "Education",
    caption: "Morning gathering.",
    alt: "Students lined up for morning assembly and prayer"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/b92ed635c12fcaf48491707e12eab5cd.jpeg",
    category: "Education",
    caption: "Dreams taking flight.",
    alt: "Student Mariam smiling while studying"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/1485015ec55730083f0618a640d8fc98.jpeg",
    category: "Education",
    caption: "Dedication to learning.",
    alt: "Student diligently working on schoolwork"
  },
  
  // Nutrition & Feeding
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/bbd9309df6d318a7c2b8ef0b452c9b1e.jpeg",
    category: "Nutrition",
    caption: "Nourishing the future with warm meals.",
    alt: "Children eating a nutritious meal provided by the feeding program"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/e06079f29fbfc9b22098a2faa4561dde.jpeg",
    category: "Nutrition",
    caption: "Shared blessings at lunch.",
    alt: "Group of children sharing a large communal meal bowl"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/dc7eb88b5901d7044887350acce3d65c.jpeg",
    category: "Nutrition",
    caption: "Providing nutritious meals daily.",
    alt: "Child eating rice and protein lunch at school"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/db705abfbc14e9f873437ede02f7ffa2.jpeg",
    category: "Nutrition",
    caption: "Fueling the mind.",
    alt: "Close up of a nutritious meal served to a student"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/f7e0680cf843587a16fb2231f98ffec8.jpeg",
    category: "Nutrition",
    caption: "Providing healthy meals.",
    alt: "Staff serving food to children in the cafeteria line"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/c75b9d745499d51acdb234273049534a.jpeg",
    category: "Nutrition",
    caption: "Abundance for all.",
    alt: "Large pots of food prepared for the school feeding program"
  },
  
  // Community & Joy
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/5cb8114a405a2170c4ce4c44746d842d.jpeg",
    category: "Community",
    caption: "Shared meals, shared joy.",
    alt: "Community members eating and laughing together"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/d7f0e9849f865c6bd8f0616875d33d47.jpeg",
    category: "Community",
    caption: "Friendship and faith growing together.",
    alt: "Two young friends smiling with arms around each other"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/46d22c5c7731e03dbb7c728a84a1c075.jpeg",
    category: "Community",
    caption: "Students gathering in the school hall.",
    alt: "Large assembly of students sitting together in the school hall"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/a235e8e42f4ec1a7e9b329b82e8c537f.jpeg",
    category: "Community",
    caption: "Serving with joy.",
    alt: "Volunteer staff member smiling while serving"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/af4037b25990ad0833008095c2a11490.jpeg",
    category: "Community",
    caption: "The simple joy of a new toy.",
    alt: "Child holding a new toy with a beaming smile"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/9c867262165d3888129a007161b14f27.jpeg",
    category: "Community",
    caption: "Moments of joy.",
    alt: "Candid shot of children laughing and playing"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/f4fb6a7b78fff8794c735fc7e906993d.jpeg",
    category: "Community",
    caption: "Sweet treats.",
    alt: "Children enjoying a special dessert treat"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/fa48a58a04ccc64559e8ab9a84c3e00a.jpeg",
    category: "Community",
    caption: "Joyful moments.",
    alt: "Group photo of students and teachers smiling"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/b9fac51f4c19bede108ea9405d350ba7.jpeg",
    category: "Community",
    caption: "Warm welcomes.",
    alt: "Community members greeting visitors with smiles"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/c399b3412a8dc01532054672dbc60616.jpeg",
    category: "Community",
    caption: "Joy of giving.",
    alt: "Distributing gifts to children in a rural village"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/5d9895a8e6083669ffaa4444f6e50851.jpeg",
    category: "Community",
    caption: "A community united in hope.",
    alt: "Entire student body and staff of Escola Cristã Barca de Noé gathering together in unity"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/c4fccb3d7d3b5939606711b6ca44aa9e.jpeg",
    category: "Community",
    caption: "Compassion in action.",
    alt: "Sharing love and hope with children"
  },
  
  // Faith & Worship
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/f7c05afb8b4b237c28a1f0f023919cf7.jpeg",
    category: "Faith",
    caption: "Gratitude and prayer before the meal.",
    alt: "Children bowing heads in prayer over their food"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/8737284c133d90a3be4bbe29079cbf59.jpeg",
    category: "Faith",
    caption: "United in song.",
    alt: "Congregation singing worship songs together"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/e9bc74681ffe16a90563305596198f1c.jpeg",
    category: "Faith",
    caption: "Growing in faith together.",
    alt: "Youth group gathering with Pastor Antonio"
  },
  
  // Achievement & Graduation
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/fccf0d7f1b797850d68ea6f9fe8a6f8b.jpeg",
    category: "Achievement",
    caption: "Celebrating milestones: Graduates ready for the future.",
    alt: "School graduates in caps and gowns holding diplomas"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/e9b2ca320c44ee1c0e49f84e874494e9.jpeg",
    category: "Achievement",
    caption: "Certificates of completion.",
    alt: "Student proudly displaying a certificate of achievement"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/e635d115a90b5a90393c5c4e599b9e06.jpeg",
    category: "Achievement",
    caption: "Proud graduates.",
    alt: "Group of graduates smiling at the camera"
  },
  {
    src: "https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/961cff5a0662947e4490f866615cf45e.jpeg",
    category: "Achievement",
    caption: "Graduation day ceremony.",
    alt: "Graduation ceremony with students in formal attire"
  }
];

const IMAGES_PER_PAGE = 12;

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [visibleCount, setVisibleCount] = useState(IMAGES_PER_PAGE);

  const visibleImages = useMemo(() => {
    return allImages.slice(0, visibleCount);
  }, [visibleCount]);

  const handleLoadMore = () => {
    setVisibleCount(prev => Math.min(prev + IMAGES_PER_PAGE, allImages.length));
  };

  return (
    <>
      <Helmet>
        <title>Photo Gallery | AGIR USA</title>
        <meta name="description" content="See our mission in action. Browse photos of our schools, feeding programs, and community events in Guinea-Bissau." />
      </Helmet>

      {/* Hero Section - Matching About Page Style */}
      <div className="relative py-32 md:py-48 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/b23737eec191c3f5b765303f85ce3a4932597ae054cc2b3dadfd019ed91c748ca1e6808982e16c775001fce05a7fb0b4/images/aW1hZ2UvanBlZw==/fa48a58a04ccc64559e8ab9a84c3e00a.jpeg" 
            alt="Group of students and teachers smiling together" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-primary-dark/80 mix-blend-multiply"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10 text-center text-white">
          <motion.div 
            initial={{ opacity: 0, y: 20 }} 
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="font-heading text-5xl md:text-7xl font-bold mb-6">Our Work in Action</h1>
            <p className="text-xl md:text-2xl text-gray-200 max-w-2xl mx-auto leading-relaxed font-light">
              Witness the <span className="text-secondary italic">smiles, the learning, and the hope</span> your support creates.
            </p>
          </motion.div>
        </div>
      </div>

      <Section>
        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {visibleImages.map((img, index) => (
            <motion.div 
              key={`${img.src}-${index}`}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "50px" }}
              transition={{ duration: 0.4, delay: index % 3 * 0.1 }}
              className="relative group cursor-pointer overflow-hidden rounded-xl shadow-md bg-gray-100 aspect-[4/3]"
              onClick={() => setSelectedImage(img)}
            >
              <img 
                src={img.src} 
                alt={img.alt || img.caption} 
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
                width="800"
                height="600"
                decoding="async"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                <span className="text-secondary text-xs font-bold uppercase tracking-wider mb-2">{img.category}</span>
                <p className="text-white text-sm font-medium">{img.caption}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Load More Button */}
        {visibleCount < allImages.length && (
          <div className="flex justify-center mt-12">
            <Button 
              onClick={handleLoadMore} 
              variant="outline" 
              size="lg"
              className="px-12 py-4"
            >
              Load More Photos ({allImages.length - visibleCount} remaining)
            </Button>
          </div>
        )}
      </Section>

      {/* Lightbox Modal */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4 backdrop-blur-sm"
            onClick={() => setSelectedImage(null)}
          >
            <button 
              className="absolute top-6 right-6 text-white/50 hover:text-white transition-colors z-50 p-2"
              onClick={() => setSelectedImage(null)}
              aria-label="Close gallery"
            >
              <SafeIcon icon={FiIcons.FiX} className="text-4xl" />
            </button>
            
            <motion.div 
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="max-w-5xl max-h-[90vh] w-full flex flex-col items-center relative"
              onClick={(e) => e.stopPropagation()}
            >
              <img 
                src={selectedImage.src} 
                alt={selectedImage.alt || selectedImage.caption} 
                className="max-w-full max-h-[80vh] rounded-lg shadow-2xl mb-6 object-contain" 
              />
              <div className="text-center">
                <h3 className="text-secondary font-bold uppercase tracking-widest text-sm mb-2">{selectedImage.category}</h3>
                <p className="text-white text-lg font-medium">{selectedImage.caption}</p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Gallery;